import { Post } from "../core/Helper";

export class SubSpecialService {
  static async GetList(params) {
    let result = await Post("api/goods/list-specialty-sub", params);
    return result ?? null;
  }

  // api/goods/specialty-sub-save

  static async SaveData(params) {
    let result = await Post("api/goods/specialty-sub-save", params);
    return result ?? null;
  }

  static async GetListForBranch(params) {
    let result = await Post("api/goods/list-specialty-sub-branch", params);
    return result ?? null;
  }

  //   static async GetData(params) {
  //     let result = await Post("api/goods/getData", params);
  //     return result ?? null;
  //   }

  //   static async Delete(params) {
  //     let result = await Post("api/goods/delete", params);
  //     return result ?? null;
  //   }

  //   static async SelectedList(params) {
  //     let result = await Post("api/goods/selected-lists", params);
  //     return result ?? null;
  //   }

  //   static async GoodUpdate(params) {
  //     let result = await Post("api/goods/update", params);
  //     return result ?? null;
  //   }
}
